import React from "react";
import { Col, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import ChoiceInput from "../../choiceInput";
import ReactTooltip from "react-tooltip";

interface Props {
  enableSalutationMessage: boolean;
  updateEnableSalutationMessage: () => void;
}

class EnableSalutationMessageCheckbox extends React.PureComponent<Props> {
  static defaultProps = {
    enableSalutationMessage: false,
  };

  render() {
    return (
      <Col className={s.content} md={12} sm={12}>
        <Row>
          <ChoiceInput
            title={"Add email salutation "}
            checked={this.props.enableSalutationMessage}
            onChangeHandler={this.props.updateEnableSalutationMessage}
            id={
              "enableSalutationMessage" +
              (this.props.enableSalutationMessage ? "_checked" : "_unchecked")
            }
            showInfo={true}
            infoId={"SalutationMessageOption"}
          />
          <ReactTooltip
            id={`tpSalutationMessageOption`}
            type="info"
            place="top"
            effect="float"
          >
            Include salutation message (e.g. "Dear John") in email
            notifications.
          </ReactTooltip>
        </Row>
      </Col>
    );
  }
}

export default withStyles(s)(EnableSalutationMessageCheckbox);
